/**
 * True once seat usage is confirmed to exceed the seats a workspace's
 * subscription actually allocates.
 *
 * `allowedSeats` of 0 means "no subscription to be over", not "a cap of zero" —
 * every free or solo workspace reports 0 purchased seats with at least one
 * active member, so treating 0 as the strictest possible limit puts a permanent
 * over-seats banner in front of every non-paying user. Seat overage is a
 * condition of a paid plan, so a workspace with no allocation is never over.
 *
 * Deliberately plan-agnostic above that: `allowedSeats` should already be the
 * real bundled entitlement for whatever plan is active (e.g. 3 for
 * Professional, 1 for Starter, the purchased quantity for Team) — every paid
 * plan participates in this check the same way.
 *
 * `hasLoaded` gates the result false while billing data is still loading (or
 * failed to load), so the banner never flashes true before real numbers
 * arrive, and fails closed rather than open on error.
 */
export function computeIsOverSeats({
  hasLoaded,
  usedSeats,
  allowedSeats,
}: {
  hasLoaded: boolean;
  usedSeats: number;
  allowedSeats: number;
}): boolean {
  return hasLoaded && allowedSeats > 0 && usedSeats > allowedSeats;
}
